// CategorieCount.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function CategorieCount({ data, onCountLoaded }) {
    const [counter, setCounter] = useState(null);

    useEffect(() => {
        if (data) {
            axios.get(`categorie_cvs/${data}`)
                .then(response => {
                    if (response.status === 200) {
                        const countValue = response.data.counter;
                        setCounter(countValue);
                        if (onCountLoaded) onCountLoaded(countValue);
                    }
                })
                .catch(error => console.error("Error fetching counter:", error));
        }
    }, [data]);

    if (counter === null) return null; // Don't render if counter is null

    return (
        <span className="badge badge-pill badge-primary">
            + {counter} CV
        </span>
    );
}
